import {ActionTree} from "vuex";
import {DataPropertyImplementationState, DataPropertyImplementation} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<DataPropertyImplementationState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/data_property_implementations', {params: params})
        .then((response: AxiosResponse) => {
          const dataPropertyImplementations: DataPropertyImplementation[] = response.data;
          commit('setDataPropertyImplementations', dataPropertyImplementations);
          return dataPropertyImplementations;
        });
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/data_property_implementations', params)
        .then((response: AxiosResponse) => {
          const dataPropertyImplementation: DataPropertyImplementation = response.data;
          commit('addDataPropertyImplementation', dataPropertyImplementation);
          return dataPropertyImplementation;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/data_property_implementations/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const dataPropertyImplementation: DataPropertyImplementation = response.data;
          commit('updateDataPropertyImplementation', dataPropertyImplementation);
          return dataPropertyImplementation;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/data_property_implementations/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteDataPropertyImplementation', id);
        });
  }
}

export default actions;
